import axios from 'axios';

const API_URL = '/api';
const TOKEN_KEY = 'sgv_dashboard_auth_token';
const USER_KEY = 'sgv_dashboard_user';

// Iniciar sesión
export const login = async (email, password) => {
  try {
    const response = await axios.post(`${API_URL}/auth/login`, { email, password });
    const { token, user } = response.data;
    
    // Guardar token y datos de usuario en localStorage
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
    
    return response.data;
  } catch (error) {
    console.error('Error al iniciar sesión:', error);
    throw error;
  }
};

// Cerrar sesión
export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

// Obtener token
export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

// Obtener usuario
export const getUser = () => {
  const userStr = localStorage.getItem(USER_KEY);
  return userStr ? JSON.parse(userStr) : null;
};

// Verificar si el usuario está autenticado
export const isAuthenticated = () => {
  return !!getToken();
};

// Verificar si el usuario es administrador
export const isAdmin = () => {
  const user = getUser();
  return user?.rol === 'admin';
};

// Configurar interceptor de Axios para añadir el token a las solicitudes
export const setupAxiosInterceptors = () => {
  axios.interceptors.request.use(
    (config) => {
      const token = getToken();
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  
  // Interceptor para manejar errores 401 (no autorizado)
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        // Redirigir a login si hay error de autenticación
        logout();
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }
  );
}; 